<template>
    <div v-bind:class="rowClass">
        <input type="checkbox" class="form-check-input" v-bind:id="id" v-bind:checked="value" v-on:input="handleCheckboxClicked($event)">
        <label class="form-check-label" v-bind:for="id">{{ label }}</label>
    </div>
</template>

<script>
export default {
    name: "VSLCheckboxRowRenderer",
    props: {
        id: String,
        label: String,
        value: Boolean,
        noSeparator: String
    },

    methods: {
        rowClass() {
            return this.noSeparator == "true" ? "vsl-row-no-separator vsl-text-input-row form-check" : "vsl-row vsl-text-input-row form-check";
        },

        handleCheckboxClicked(event) {
            this.$emit('input', event.target.checked);
        }
    }
}
</script>

<style scoped>
.form-check-input {
    margin-right: 8px;
}
</style>